import session from 'lib/session';
import { withPropsOnChange } from 'recompose';
import { createAction } from 'redux-actions';
import { put as sagaPut, takeEvery } from 'redux-saga/effects';
import { error, field } from 'redux/shelf';
import { get, post, put, search } from 'redux/shelf/api';
import { createReducer } from 'redux/shelf/reducer';

export const actions = {
  createField: post`fields/${session.getMerchant}/shopify/custom-fields`(),
  updateFields: put`fields/${session.getMerchant}/update`(),
  updateRanks: put`fields/${session.getMerchant}/update-ranks`(),
  updateField: put`fields/${session.getMerchant}/:id`(),
  fetchValues: search.post`/facet/values`(
    (res, meta) =>
      res.facets[0] && {
        [meta.name]: {
          filterCount: res.facets[0].values.length,
          productCount: res.facets[0].total,
        },
      }
  ),
  fetchList: get`fields/${session.getMerchant}`(field('fields')),
  updateList: put`fields/${session.getMerchant}`(),
  update: createAction('filters.update'),
};

export const reducer = createReducer([actions.fetchList], {
  [actions.update]: (s, { payload }) => ({
    ...s,
    fields: Array.isArray(payload)
      ? payload
      : s.fields.map((f) => (f.id === payload.id ? { ...f, ...payload } : f)),
  }),
  [actions.fetchValues]: (s, { payload }) => ({
    ...s,
    values: {
      ...s.values,
      ...payload,
    },
  }),
});

export const saga = [
  (function* () {
    yield takeEvery(error(actions.updateField), function* () {
      try {
        // @ts-ignore
        yield sagaPut(actions.fetchList());
      } catch (er) {
        console.error(er);
      }
    });
  })(),
  (function* () {
    yield takeEvery(error(actions.updateFields), function* () {
      // @ts-ignore
      yield sagaPut(actions.fetchList());
    });
  })(),
];

const buildFilterKey = (action: string, name: string) => action + name;

export const reduceFilterOptions = (
  options: object = {},
  selectedFilters: string[] = [],
  currentFilterAction: string,
  currentValue?: string
) =>
  Object.keys(options).reduce(
    (acc, key) => ({ ...acc, [key]: options[key] }),
    (currentValue && { [currentValue]: options[currentValue] }) || {}
  );

export const createFilterActionsReducer =
  (actions: object = {}) =>
  (
    selectedFilters: string[] = [],
    currentFilterName: string,
    currentAction: string
  ) =>
    !currentFilterName
      ? actions
      : Object.keys(actions)
          .filter(
            (key) =>
              !selectedFilters.includes(buildFilterKey(key, currentFilterName))
          )
          .reduce(
            (acc, key) => ({ ...acc, [key]: actions[key] }),
            (currentAction && { [currentAction]: actions[currentAction] }) || {}
          );

export const withSelectedFilters = (
  formDataPropName: string,
  filtersGetter: (obj: any) => any[]
) =>
  withPropsOnChange(
    [formDataPropName],
    ({ [formDataPropName]: formData }: { [key: string]: any }) => {
      return {
        selectedFilters: filtersGetter(formData).map((f) =>
          buildFilterKey(f.action, f.name)
        ),
      };
    }
  );
